import { base_url } from './base_values';
export const getAllUsers = async token => {
  const response = await fetch(base_url + 'api/users/get_all_users', {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  return result;
};
export const getAllUsersForUsername = async (token, username) => {
  const response = await fetch(
    base_url + `api/users/get_all_users_for_username?username=${username}`,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  return result;
};
export const getAllPanels = async token => {
  const response = await fetch(base_url + 'api/panels/get_all_panels', {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  return result;
};

export const getAllRoles = async token => {
  const response = await fetch(base_url + 'api/users/get_all_roles', {
    method: 'GET',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });
  const result = await response.json();
  return result;
};
export const createUser = async (values, token) => {
  console.log(values);
  const response = await fetch(base_url + 'api/users/add_user', {
    method: 'POST',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });
  const result = await response.json();
  return result;
};

export const getUserById = async (user_id, token) => {
  console.log(user_id);
  const response = await fetch(
    base_url + `api/users/get_user_by_id/${user_id}`,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  return result;
};
export const getDocByUserId = async user_id => {
  console.log(user_id);
  const response = await fetch(
    base_url + `api/files/generate-docx/${user_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
      },
    }
  );
  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);

  // Создаем временный <a> элемент
  const a = document.createElement('a');
  a.href = url;
  a.download = 'customer_info.docx'; // Имя файла для скачивания
  document.body.appendChild(a);
  a.click();

  // Удаляем элемент после скачивания
  a.remove();
  window.URL.revokeObjectURL(url);
};

export const updateUserById = async (user_id, values, token) => {
  const response = await fetch(
    base_url + `api/users/update_user_by_id/${user_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    }
  );
  const result = await response.json();
  return result;
};

export const deleteUserById = async (user_id, token) => {
  const response = await fetch(base_url + `api/users/delete_user/${user_id}`, {
    method: 'DELETE',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Не удалось удалить пользователя');
  }

  return response.status === 204 ? null : response.json();
};

export const createPanel = async (values, user_id, token) => {
  console.log(values);
  const response = await fetch(
    base_url + `api/panels/add_panel?user_id=${user_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    }
  );
  const result = await response.json();
  return result;
};

export const getPanelById = async (panel_id, token) => {
  const response = await fetch(
    base_url + `api/panels/get_panel_by_id/${panel_id}`,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const updatePanelById = async (panel_id, values, token) => {
  const response = await fetch(
    base_url + `api/panels/update_panel_by_id/${panel_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    }
  );
  const result = await response.json();
  return result;
};

export const deletePanelById = async (panel_id, token) => {
  const response = await fetch(
    base_url + `api/panels/delete_panel/${panel_id}`,
    {
      method: 'DELETE',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );

  if (!response.ok) {
    throw new Error('Не удалось удалить панель');
  }

  return response.status === 204 ? null : response.json();
};

export const createRole = async (values, token) => {
  console.log(values);
  const response = await fetch(base_url + `api/users/add_role`, {
    method: 'POST',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });
  const result = await response.json();
  return result;
};

export const updateRoleById = async (values, role_id, token) => {
  const response = await fetch(
    base_url + `api/users/update_role_by_id/${role_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    }
  );
  const result = await response.json();
  return result;
};

export const getRoleById = async (role_id, token) => {
  console.log(role_id);
  const response = await fetch(
    base_url + `api/users/get_role_by_id/${role_id}`,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const deleteRoleById = async (role_id, token) => {
  const response = await fetch(base_url + `api/users/delete_role/${role_id}`, {
    method: 'POST',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error('Не удалось удалить роль');
  }

  return response.status === 204 ? null : response.json();
};

export const getAllPanelsById = async (user_id, token) => {
  const response = await fetch(
    base_url + `api/panels/get_all_panels_id/${user_id}`,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  return result;
};
export const getAllPanelsByGroups = async (user_id, token) => {
  const response = await fetch(
    base_url + `api/panels/get_all_panels/groups/user/${user_id}`,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  console.log(result);
  return result;
};

export const addPanelToGroup = async (panel_id, group_id, token) => {
  const response = await fetch(
    base_url +
      `api/panels/add_panel_to_group?panel_id=${panel_id}&group_id=${group_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  console.log(result);
  return result;
};
export const getAllGroups = async (user_id, token) => {
  const response = await fetch(
    base_url + `api/users/get_all_groups/user/${user_id}`,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  return result;
};

export const deletePanelFromGroup = async (panel_id, group_id, token) => {
  const response = await fetch(
    base_url +
      `api/panels/delete_panel_from_group?panel_id=${panel_id}&group_id=${group_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  console.log(result);
  return result;
};

export const deleteGroup = async (group_id, token) => {
  const response = await fetch(
    base_url + `api/users/delete_group/${group_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  console.log(result);
  return result;
};

export const addGroup = async (values, user_id, token) => {
  console.log(values);
  const response = await fetch(base_url + `api/users/add_group/${user_id}`, {
    method: 'POST',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });
  const result = await response.json();
  console.log(result);
  return result;
};

export const addManyChanges = async (values, group_id, token) => {
  console.log(values);
  const response = await fetch(
    base_url + `api/panels/add_changes_many_panels/${group_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    }
  );
  const result = await response.json();
  console.log(result);
  return result;
};
export const addPanelToUser = async (panel_id, user_id, token) => {
  const response = await fetch(
    base_url +
      `api/panels/add_panel_user?panel_id=${panel_id}&user_id=${user_id}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  const result = await response.json();
  console.log(result);
  return result;
};

const parseApiResponse = async response => {
  const result = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(result?.detail || result?.message || 'Ошибка запроса');
  }
  return result;
};

export const getMonitoringDevices = async token => {
  const response = await fetch(base_url + 'api/monitoring/devices', {
    method: 'GET',
    headers: { accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return parseApiResponse(response);
};

export const getMonitoringDevice = async (fabricNumber, token, range = {}) => {
  const params = new URLSearchParams();
  if (range.from_at) params.set('from_at', range.from_at);
  if (range.to_at) params.set('to_at', range.to_at);
  const query = params.toString() ? `?${params.toString()}` : '';
  const response = await fetch(
    base_url + `api/monitoring/devices/${fabricNumber}${query}`,
    {
      method: 'GET',
      headers: { accept: 'application/json', Authorization: `Bearer ${token}` },
    }
  );
  return parseApiResponse(response);
};

export const getMonitoringAudit = async (token, fabricNumber = '', range = {}) => {
  const params = new URLSearchParams();
  if (fabricNumber) params.set('fabric_number', fabricNumber);
  if (range.from_at) params.set('from_at', range.from_at);
  if (range.to_at) params.set('to_at', range.to_at);
  const query = params.toString() ? `?${params.toString()}` : '';
  const response = await fetch(base_url + `api/monitoring/audit${query}`, {
    method: 'GET',
    headers: { accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return parseApiResponse(response);
};

export const runMonitoringCommand = async (fabricNumber, values, token) => {
  const response = await fetch(
    base_url + `api/monitoring/devices/${fabricNumber}/commands`,
    {
      method: 'POST',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(values),
    }
  );
  return parseApiResponse(response);
};

export const getMonitoringCommandHistory = async (fabricNumber, token) => {
  const response = await fetch(
    base_url + `api/monitoring/devices/${fabricNumber}/commands`,
    {
      method: 'GET',
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${token}`,
      },
    }
  );
  return parseApiResponse(response);
};

export const getMonitoringAlertSettings = async token => {
  const response = await fetch(base_url + 'api/monitoring/alert-settings', {
    method: 'GET',
    headers: { accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return parseApiResponse(response);
};

export const updateMonitoringAlertSettings = async (values, token) => {
  const response = await fetch(base_url + 'api/monitoring/alert-settings', {
    method: 'POST',
    headers: {
      accept: 'application/json',
      Authorization: `Bearer ${token}`,
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(values),
  });
  return parseApiResponse(response);
};

export const getBotTickets = async (filters, token) => {
  const params = new URLSearchParams();
  Object.entries(filters || {}).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.set(key, value);
    }
  });
  const response = await fetch(base_url + `api/bot-tickets?${params.toString()}`, {
    method: 'GET',
    headers: { accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return parseApiResponse(response);
};

export const getBotTicketSuggestions = async (q, token) => {
  const response = await fetch(base_url + `api/bot-tickets/suggest?q=${encodeURIComponent(q || '')}`, {
    method: 'GET',
    headers: { accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return parseApiResponse(response);
};

export const getBotTicket = async (ticketId, token) => {
  const response = await fetch(base_url + `api/bot-tickets/${encodeURIComponent(ticketId)}`, {
    method: 'GET',
    headers: { accept: 'application/json', Authorization: `Bearer ${token}` },
  });
  return parseApiResponse(response);
};
